import request from '@/utils/request'


// 查询设备质保记录列表
export function listWarrantyRecord(query) {
  return request({
    url: '/equipment/warrantyRecord/list',
    method: 'get',
    params: query
  })
}

// 查询设备质保记录分页
export function pageWarrantyRecord(query) {
  return request({
    url: '/equipment/warrantyRecord/page',
    method: 'get',
    params: query
  })
}

// 查询设备质保记录详细
export function getWarrantyRecord(data) {
  return request({
    url: '/equipment/warrantyRecord/detail',
    method: 'get',
    params: data
  })
}

// 新增设备质保记录
export function addWarrantyRecord(data) {
  return request({
    url: '/equipment/warrantyRecord/add',
    method: 'post',
    data: data
  })
}

// 修改设备质保记录
export function updateWarrantyRecord(data) {
  return request({
    url: '/equipment/warrantyRecord/edit',
    method: 'post',
    data: data
  })
}

// 删除设备质保记录
export function delWarrantyRecord(data) {
  return request({
    url: '/equipment/warrantyRecord/delete',
    method: 'post',
    data: data
  })
}
